<template>
  <div class="teamDetail">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose">
      战队名称: <el-input size="small" v-model="filter.teamName" style="width: 150px" placeholder="请输入战队名称"></el-input>
      段位: <el-select v-model="filter.grade" placeholder="全部段位" size="small" filterable>
        <el-option v-for="(item, i) in danList" :key="i" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button type="primary" size="small" style="margin: 0 10px;" @click="search">查询</el-button>
      <el-button type="" size="small" @click="reset">重置</el-button>
      <el-button type="primary" size="small" class="fr">导出</el-button>

      <el-table style="margin-top: 10px" :data="list" border>
        <el-table-column align="center" label="战绩/销售业绩/段位" prop="">
          <template slot-scope="scope">
            {{scope.row.seasonTeamAName + '/' + scope.row.seasonTeamAAchievement + '/' + danList[scope.row.grade - 1].name}}
          </template>
        </el-table-column>
        <el-table-column align="center" label="PK战队名称/销售业绩/段位" prop="">
          <template slot-scope="scope">
            {{scope.row.seasonTeamBName + '/' + scope.row.seasonTeamBAchievement + '/' + danList[scope.row.grade - 1].name }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="胜利战队" prop="">
          <template slot-scope="scope">
            <span v-if="scope.row.victoryTeamId === scope.row.seasonTeamAId">{{scope.row.seasonTeamAName}}</span>
            <span v-if="scope.row.victoryTeamId === scope.row.seasonTeamBId">{{scope.row.seasonTeamBName}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="战队奖金" prop="teamAward"></el-table-column>
        <el-table-column align="center" label="MVP人员" prop="mvpName"></el-table-column>
        <el-table-column align="center" label="MVP奖金" prop="personAward"></el-table-column>
      </el-table>
      <el-pagination
        style="text-align: center; margin-top: 10px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import { getPkListPage } from '@/api/season/vip.js'
export default {
  name: 'TeamDetail',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => {}
    },
    danList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    value(v) {
      this.dialogVisible = v
      if (v) {
        this.filter.seasonId = this.row.seasonId
        this.filter.startDate = this.row.thatDate
        this.filter.endDate = this.row.thatDate
        this.title = `${this.row.seasonName}赛季 ${this.row.thatDate.split(' ')[0]}`
        this.getPkListPage()
      }
    }
  },
  data () {
    return {
      dialogVisible: false,
      filter: {
        page: 1,
        limit: 10,
        grade: '',
        teamName: '',
        seasonId: '',
        startDate: '',
        endDate: ''
      },
      list: [],
      total: 0,
      title: ''
    }
  },
  methods: {
    async getPkListPage() {
      const res = await getPkListPage(this.filter)
      this.list = res.data.records
      this.total = +res.data.total
    },
    search() {
      this.filter.page = 1
      this.getPkListPage()
    },
    reset() {
      this.filter.page = 1
      this.filter.limit = 10
      this.filter.teamName = ''
      this.filter.grade = ''
      this.getPkListPage()
    },
    handleClose() {
      this.$emit('input', false)
      this.filter = {
        page: 1,
        limit: 10,
        grade: '',
        teamName: '',
        seasonId: '',
        startDate: '',
        endDate: ''
      }
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getPkListPage()
    },
    handleSizeChange(v) {
      this.filter.limit = v
      this.filter.page = 1
      this.getPkListPage()
    }
  }
}
</script>

<style lang="scss" scoped>
.teamDetail {
  .fr {
    float: right;
  }
}
</style>
